module.exports = "span {\n    color: red;\n    font-size: 12px;\n}\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/contact-us/contact-us.component.css
// module id = ./src/app/shared/component/contact-us/contact-us.component.css
// module chunks = main